import styled from "styled-components";
import { ExternalLink } from "@pepdirect/v3/ui/ExternalLink";

export const StyledExternalLink = styled(ExternalLink)`
  cursor: pointer;
  text-decoration: underline;
`;

export const Status = styled.span`
  color: ${({ theme }) => theme.color.text};
`;

export const StyledTrackingInfo = styled.span`
  &,
  a {
    color: ${({ theme }) => theme.color.primary};
  }
  margin-left: 10px;
`;
